import { ReactLenis } from 'lenis/react'

export default function SmoothScroll({children}) {

    // const [updateKey, setUpdateKey]= useState(null);
    // useEffect(() => {
    //     const timer = setTimeout(() => {
    //         setUpdateKey(key);
    //     }, 1);
    // }, [key]);

    const options = {
        lerp: 0.2
    }

    // const lenis = useLenis(() => {});
    // const ref = useRef();
    // useEffect(() => {

    // }, [newKey]);



    return (
        <ReactLenis 
            // key={newKey}
            options={options}
            root
        >
            {children}
        </ReactLenis>
    );
}
